/**
 * Append a count suffix to a filter label when there is at least one selection.
 * Examples: getCountedLabel('Flow', 0) → 'Flow'; getCountedLabel('Flow', 2) → 'Flow (2)'.
 */
export const getCountedLabel = (label: string, count: number): string =>
  count > 0 ? `${label} (${count})` : label;
